import Slider from "react-slick";

const settings = {
  dots: false,
  arrows: false,
  slidesToShow: 6,
  infinite: true,
  autoplay: true,
  slidesToScroll: 1,
  pauseOnHover: false,
  cssEase: "linear",
  autoplaySpeed: 0,
  speed: 6000,
  remove: true,
  centerMode: true,
  responsive: [
    {
      breakpoint: 2560,
      settings: {
        slidesToShow: 8,
      },
    },
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 8,
      },
    },
    {
      breakpoint: 1599,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

export default function AboutLogoslider() {
  return (
    <>
    <section className="clientlogo-slider">
        <Slider {...settings}>
            <div className="clientlogo-box">
                <img src="/image/logoslide-1.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-2.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-3.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-4.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-5.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-6.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-7.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-8.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-9.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-10.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-11.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-12.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-13.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>

            <div className="clientlogo-box">
                <img src="/image/logoslide-14.webp" className="img-responsive" alt="logo" loading="lazy"/>
            </div>
        </Slider>
    </section>
    </>
  )
}
